<template>
    <div>
        <div class="items_list white">
            <div class="item" v-for="chatGroup in chatGroups" v-show="chatGroup.favorite_message" 
                 :key="chatGroup.id"
                 @click="handleClickChatGroup(chatGroup)"
            >
                <span class="text">{{`${chatGroup.company.short_name}  ${chatGroup.market_code}`}}</span>
                <div class="item_button button button_small button_rounded bordered deep_blue"
                     @click.stop="showParticipants(chatGroup)">
                    <span class="icon icon_users_group"></span>
                    メンバー
                </div>
            </div>

            <infinite-loading @infinite="paginate">
                <div slot="spinner"></div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>

        <Modal :title="modal.title"
               :content="modal.content"
               type="chat-group"
               v-show="modal.show"
               @cancel="modal.show = false"
        />
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import InstitutionApi from '@/api/institution'
  import ChatGroupApi from '@/api/chat-group'
  import Modal from '@/components/modal'

  export default {
    components: {
      Modal
    },
    data () {
      return {
        institution: {},
        chatGroups: [],
        modal: {
          show: '',
          title: '',
          content: ''
        }
      }
    },
    methods: {
      ...mapActions({
        setLinks: 'navigator/setLinks',
        getParticipateChatGroups: 'institution/getParticipateChatGroups',
        setFineplay: 'navigator/setFineplay'
      }),
      async handleClickChatGroup (chatGroup) {
        this.$router.push({
          name: 'chat',
          params: {
            chatGroupId: chatGroup.id,
            messageId: chatGroup.favorite_message.id
          }
        })
      },
      async setNavigatorLinks () {
        const institutionCode = this.$route.params.institutionCode
        const res = await InstitutionApi.show(institutionCode)
        this.institution = res.data.data
        this.setLinks([{title: this.institution.official_name_kanji, route: {name: 'shares'}}])
      },
      paginate ($state) {
        setTimeout(async () => {
          const institutionCode = this.$route.params.institutionCode
          const res = await ChatGroupApi.get({
            institution_code: institutionCode,
            offset: this.chatGroups.length
          })
          this.chatGroups = [...this.chatGroups, ...res.data.data]
        })
      },
      showParticipants (chatGroup) {
        this.modal.show = true
        this.modal.title = `${chatGroup.company.short_name} ${chatGroup.market_code}`
        let content = ''
        chatGroup.employees.forEach(n => {
          content += `${n.display_name}<br>`
        })
        this.modal.content = content
      }
    },
    mounted () {
      this.setNavigatorLinks()
      this.setFineplay(false)
    }
  }
</script>




// WEBPACK FOOTER //
// src/screens/shares/show.vue